// @ts-nocheck
import ExcelJS from "exceljs";
import { useState } from "react";
import Loading from "src/components/Loading";
import { DownloadIcon } from "src/components/ui-icons/upload";
import TGButton from "src/components/ui/TGButton";
import { FlexCol } from "src/utils/flexLayouts";


export const createExcelBlob = (exportData, fileName, type) => {
  if (!exportData?.data.length) return Promise.resolve();

  const workbook = new ExcelJS.Workbook();
  const sheet = workbook.addWorksheet(fileName);
  sheet.properties.defaultRowHeight = 40;
  sheet.columns = exportData.columns;

  const promise = Promise.all(
    exportData.data.map(async (row, index) => {
      sheet.addRow(row);
    })
  );

  return promise.then(() => {
    sheet.getRow(1).alignment = { vertical: "middle", horizontal: "center", wrapText: true };
    const actionLinksColumnIndex = sheet.columns.findIndex((column) => column.key === "ActionLinks") + 1;
    const actionLinksColumn = actionLinksColumnIndex > 0 ? sheet.getColumn(actionLinksColumnIndex) : null;

    if (actionLinksColumn) {
      actionLinksColumn.eachCell((cell, rowNumber) => {
        if (rowNumber === 1 || typeof cell.value !== "string") {
          return;
        }

        const actionIds = cell.value.split("\n").filter(Boolean);

        if (actionIds.length === 1) {
          const actionId = actionIds[0];
          cell.value = {
            text: actionId,
            hyperlink: `https://supply.napitkivmeste.ru/dashboard/3?actionCard=${actionId}`,
          };
          cell.font = {
            color: { argb: "0563C1" },
            underline: true,
          };
        }

        cell.alignment = {
          vertical: "middle",
          horizontal: "left",
          wrapText: true,
        };
      });
    }

    if (type === "owd_calendar") {
      /** --------- ШАПКА --------- */

      // 1 строка — дата (mergeCells)
      sheet.getRow(1).height = 32;
      sheet.getRow(1).font = {
        size: 16,
        bold: true,
      };
      sheet.getRow(1).alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };

      // 2 строка — Дата план / ФИО эксперта / Дата факт
      sheet.getRow(2).height = 28;
      sheet.getRow(2).font = {
        size: 14,
        bold: true,
      };
      sheet.getRow(2).alignment = {
        vertical: "middle",
        horizontal: "center",
        wrapText: true,
      };
      sheet.getRow(2).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "FFCCCCCC" },
      };

      /** --------- ДАННЫЕ --------- */

      sheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number > 2) {
          row.eachCell({ includeEmpty: true }, (cell) => {
            // ❗️ НЕ трогаем cell.value (иначе richText сломается)
            cell.alignment = {
              vertical: "middle",
              horizontal: "center", // если надо — "left"
              wrapText: true,
            };
          });
        }
      });
    } else if (type === "action_reports") {
      sheet.columns.forEach((column, index) => {
        column.alignment = {
          wrapText: true,
        };

        if (index === 0 || index === 3 || (index > 13 && index <= 24)) {
          column = {
            fill: {
              type: "pattern",
              pattern: "solid",
              fgColor: { argb: "CCCCCC" },
            },
          };
        }
      });

      sheet.getRow(1).eachCell((cell, colNumber) => {
        cell.alignment = {
          vertical: "middle",
          horizontal: "left", // Выравнивание по левому краю
          wrapText: true,
          indent: 1, // Добавление отступа слева
        };
      });

      sheet.getRow(1).font = {
        size: 13,
        bold: true,
      };
    } else if (type === "audit_report") {
      sheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number > 1) {
          row.eachCell((cell, colNumber) => {
            cell.alignment = {
              vertical: "middle",
              horizontal: "left", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };

            if (colNumber === 4 || colNumber === 6 || colNumber === 7) {
              cell.alignment = {
                vertical: "middle",
                horizontal: "center", // Выравнивание по центру
                wrapText: true,
                indent: 1,
              };
            }
          });
        } else {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              right: {
                color: "#ccc",
                style: "thin",
              },
            };

            cell.alignment = {
              vertical: "middle",
              horizontal: "center", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };
          });
        }
      });

      sheet.getRow(1).font = {
        size: 16,
        bold: true,
      };

      sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      };
    } else if (type === "notification_report") {
      sheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number > 1) {
          row.eachCell((cell, colNumber) => {
            cell.alignment = {
              vertical: "middle",
              horizontal: "left", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };

            if (colNumber === 4 || colNumber === 7) {
              cell.alignment = {
                vertical: "middle",
                horizontal: "right", // Выравнивание по центру
                wrapText: true,
                indent: 1,
              };
            }
          });
        } else {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              right: {
                color: "#ccc",
                style: "thin",
              },
            };
          });
        }
      });

      sheet.getRow(1).font = {
        size: 16,
        bold: true,
      };

      sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      };
    } else if (
      type === "employees_report" ||
      type === "my_tasks_audit" ||
      type === "report_5_way" ||
      type === "report_documents" ||
      type === "my_tasks_incidents"
    ) {
      sheet.getRow(1).font = {
        size: 16,
        bold: true,
      };
      sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      };
      sheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number > 1) {
          row.eachCell((cell, colNumber) => {
            cell.alignment = {
              vertical: "middle",
              horizontal: "left", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };
          });
        }
      });
    } else if (type === "workplace_report") {
      sheet.getRow(1).font = {
        size: 12,
        bold: true,
      };
      sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      };
      sheet.eachRow({ includeEmpty: true }, (row) => {
        row.eachCell((cell) => {
          cell.alignment = {
            vertical: "middle",
            horizontal: "left",
            wrapText: true,
            indent: 1,
          };
        });
      });
    } else if (type === "checklist_tasks") {
      const highlightPinkRowIndexes = exportData.highlightPinkRowIndexes || [];

      highlightPinkRowIndexes.forEach((dataIndex) => {
        const row = sheet.getRow(dataIndex + 2);
        row.eachCell({ includeEmpty: true }, (cell) => {
          cell.fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "FFFFEBF4" },
          };
          cell.border = {
            right: {
              color: "#ccc",
              style: "thin",
            },
          };
        });
      });

      sheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number > 1) {
          row.eachCell((cell, colNumber) => {
            cell.alignment = {
              vertical: "middle",
              horizontal: "left", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };
          });
        } else {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              right: {
                color: "#ccc",
                style: "thin",
              },
            };

            cell.alignment = {
              vertical: "middle",
              horizontal: "center", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };
          });
        }
      });

      sheet.getRow(1).font = {
        size: 12,
        bold: true,
      };

      sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      };
    } else if (type === "checklist_task") {
      sheet.eachRow({ includeEmpty: true }, (row) => {
        if (row.number > 1) {
          row.eachCell((cell, colNumber) => {
            cell.alignment = {
              vertical: "middle",
              horizontal: "left", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };
          });
        } else {
          row.eachCell((cell, colNumber) => {
            cell.border = {
              right: {
                color: "#ccc",
                style: "thin",
              },
            };

            cell.alignment = {
              vertical: "middle",
              horizontal: "center", // Выравнивание по левому краю
              wrapText: true,
              indent: 1, // Добавление отступа слева
            };
          });
        }
      });

      sheet.getRow(1).font = {
        size: 12,
        bold: true,
      };

      sheet.getRow(1).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      };
    }

    return workbook.xlsx.writeBuffer().then(function (data) {
      return new Blob([data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
    });
  });
};

export const exportExcelFile = (exportData, fileName, type, setOpenImportExel) => {
  return createExcelBlob(exportData, fileName, type).then((blob) => {
    if (!blob) {
      return;
    }

      const url = window.URL.createObjectURL(blob);
      const linkDownLoad = document.createElement("a");
      linkDownLoad.setAttribute("download", `${fileName}.xlsx`);
      linkDownLoad.setAttribute("href", url);
      linkDownLoad.style.display = "none";
      document.body.appendChild(linkDownLoad);
      linkDownLoad.click();
      document.body.removeChild(linkDownLoad);
      window.URL.revokeObjectURL(url);
      setOpenImportExel && setOpenImportExel(false);
  });
};

const ExportToExcel = ({
  disabled = false,
  exportData,
  getExportData,
  fileName,
  type,
  button = { icon: <DownloadIcon />, child: "Скачать в Excel", classNames: "min-w-[205px]", styles: {} },
  setOpenImportExel
}: any) => {
  const [isExporting, setIsExporting] = useState(false);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const actualExportData = getExportData ? await getExportData() : exportData;
      await exportExcelFile(actualExportData, fileName, type, setOpenImportExel);
    } catch (error) {
      console.error("Excel export failed", error);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <FlexCol>
      {Object.keys(exportData).length > 0 && (
        <TGButton
          disabled={disabled || isExporting}
          onClick={handleExport}
          icon={isExporting ? <Loading /> : button.icon}
          iconStyle="w-5 h-5"
          className={button.classNames}
          style={button.styles}
        >
          {button.child}
        </TGButton>
      )}
    </FlexCol>
  );
};

export default ExportToExcel;
